import { render, staticRenderFns } from "./CategoryAdditionalFeeListItem.vue?vue&type=template&id=4248c255&scoped=true&"
import script from "./CategoryAdditionalFeeListItem.vue?vue&type=script&lang=js&"
export * from "./CategoryAdditionalFeeListItem.vue?vue&type=script&lang=js&"
import style0 from "./CategoryAdditionalFeeListItem.vue?vue&type=style&index=0&id=4248c255&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4248c255",
  null
  
)

export default component.exports